import { render, staticRenderFns } from "./IframeTemplate.vue?vue&type=template&id=2561262a"
import script from "./IframeTemplate.vue?vue&type=script&lang=js"
export * from "./IframeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports